import React from 'react'

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'react-chartjs-2'

import { IData } from './types'

ChartJS.register(ArcElement, Tooltip, Legend)

interface PieCharProps {
  data: IData
}

const PieChart: React.FC<PieCharProps> = ({ data }) => {
  return (
    <Pie
      data={data}
      options={{
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          }
        }
      }}
    />
  )
}

export default PieChart
